import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const TermsOfUse = () => {

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="container mx-auto px-4 py-16 text-white/90 pt-24 md:pt-20">
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="text-3xl font-bold mb-8 text-[#9E7C47]">Terms of Use</h1>
          {/* <p className="text-white/70">
            Effective Date: April 16, 2025<br />
            Website: www.wealthmanager.online<br />
            Owner: WealthManager AI
          </p> */}

          <section>
            <h2 className="text-xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-white/70">
              By accessing or using WealthManager.online ("Platform"), you agree to comply with and be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, please do not use the Platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">2. Description of Services</h2>
            <p className="text-white/70">
              WealthManager AI provides AI-powered tools for financial news analysis, portfolio tracking, and market updates. These tools are intended solely for informational and educational purposes. WealthManager.online does not provide personalized investment advice or financial planning services regulated by SEBI.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">3. User Eligibility</h2>
            <p className="text-white/70">
              You must be at least 18 years old and legally competent to enter into a contract to use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">4. User Responsibilities</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-1">
              <li>Provide accurate and updated personal and financial information.</li>
              <li>Use the Platform only for lawful, personal, and non-commercial purposes.</li>
              <li>Maintain confidentiality of login credentials.</li>
              <li>Do not misuse or exploit AI-generated content.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">5. AI-Generated Content Disclaimer</h2>
            <p className="text-white/70">
              Content provided through the Platform, including financial summaries, insights, or news, is generated by artificial intelligence and should not be considered as financial advice or a substitute for a licensed financial advisor. WealthManager AI is not registered with SEBI and does not offer regulated investment advisory services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">6. Limitation of Liability</h2>
            <ul className="list-disc pl-6 text-white/70 space-y-1">
              <li>Any investment or financial losses resulting from actions taken based on Platform content</li>
              <li>Any errors, inaccuracies, or technical interruptions</li>
              <li>Any third-party content, tools, or integrations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">7. Intellectual Property</h2>
            <p className="text-white/70">
              All Platform content—including algorithms, UI/UX designs, written material, and branding—is the intellectual property of WealthManager AI or its licensors. Unauthorized use or duplication is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">8. Suspension or Termination</h2>
            <p className="text-white/70">
              We may suspend or permanently revoke access to the Platform at our discretion for violations of these Terms. Upon termination, your right to use the Platform ceases immediately.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">9. Modifications to Terms</h2>
            <p className="text-white/70">
              These Terms may be updated periodically. Continued use of the Platform after any changes constitutes your acceptance of those changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">10. Governing Law</h2>
            <p className="text-white/70">
              These Terms are governed by Indian law. Any disputes shall be subject to the exclusive jurisdiction of the courts of Bangalore, Karnataka.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-4">11. Contact Us</h2>
            <p className="text-white/70">
              For any queries regarding these Terms:
            </p>
            <p className="text-white/70 mt-4">
              WealthManager AI<br />
              Email: support@wealthmanager.online<br />
              Website: https://www.wealthmanager.online
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfUse;